// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tooltip {
	display: block !important;
	z-index: 10000;
}

.tooltip .tooltip-inner {
	background: #ccc;
	color: black;
	border-radius: 10px;
	padding: 5px 10px 4px;
}

.tooltip .tooltip-arrow {
	width: 0;
	height: 0;
	border-style: solid;
	position: absolute;
	margin: 5px;
	border-color: #ccc;
	z-index: 1;
}

.tooltip[x-placement^="top"] {
	margin-bottom: 5px;
}

.tooltip[x-placement^="top"] .tooltip-arrow {
	border-width: 5px 5px 0 5px;
	border-left-color: transparent !important;
	border-right-color: transparent !important;
	border-bottom-color: transparent !important;
	bottom: -5px;
	left: calc(50% - 5px);
	margin-top: 0;
	margin-bottom: 0;
}

.tooltip[x-placement^="bottom"] {
	margin-top: 5px;
}

.tooltip[x-placement^="bottom"] .tooltip-arrow {
	border-width: 0 5px 5px 5px;
	border-left-color: transparent !important;
	border-right-color: transparent !important;
	border-top-color: transparent !important;
	top: -5px;
	left: calc(50% - 5px);
	margin-top: 0;
	margin-bottom: 0;
}

.tooltip[x-placement^="right"] {
	margin-left: 5px;
}

.tooltip[x-placement^="right"] .tooltip-arrow {
	border-width: 5px 5px 5px 0;
	border-left-color: transparent !important;
	border-top-color: transparent !important;
	border-bottom-color: transparent !important;
	left: -5px;
	top: calc(50% - 5px);
	margin-left: 0;
	margin-right: 0;
}

.tooltip[x-placement^="left"] {
	margin-right: 5px;
}

.tooltip[x-placement^="left"] .tooltip-arrow {
	border-width: 5px 0 5px 5px;
	border-top-color: transparent !important;
	border-right-color: transparent !important;
	border-bottom-color: transparent !important;
	right: -5px;
	top: calc(50% - 5px);
	margin-left: 0;
	margin-right: 0;
}

.tooltip.popover .popover-inner {
	background: #f9f9f9;
	color: black;
	padding: 24px;
	border-radius: 5px;
	box-shadow: 0 5px 30px rgba(black, 0.1);
}

.tooltip.popover .popover-arrow {
	border-color: #f9f9f9;
}

.tooltip[aria-hidden="true"] {
	visibility: hidden;
	opacity: 0;
	transition: opacity 0.15s, visibility 0.15s;
}

.tooltip[aria-hidden="false"] {
	visibility: visible;
	opacity: 1;
	transition: opacity 0.15s;
}
`, "",{"version":3,"sources":["webpack://./client/src/css/tooltip.css"],"names":[],"mappings":"AAAA;CACC,yBAAyB;CACzB,cAAc;AACf;;AAEA;CACC,gBAAgB;CAChB,YAAY;CACZ,mBAAmB;CACnB,qBAAqB;AACtB;;AAEA;CACC,QAAQ;CACR,SAAS;CACT,mBAAmB;CACnB,kBAAkB;CAClB,WAAW;CACX,kBAAkB;CAClB,UAAU;AACX;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,2BAA2B;CAC3B,yCAAyC;CACzC,0CAA0C;CAC1C,2CAA2C;CAC3C,YAAY;CACZ,qBAAqB;CACrB,aAAa;CACb,gBAAgB;AACjB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,2BAA2B;CAC3B,yCAAyC;CACzC,0CAA0C;CAC1C,wCAAwC;CACxC,SAAS;CACT,qBAAqB;CACrB,aAAa;CACb,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;CAC3B,yCAAyC;CACzC,wCAAwC;CACxC,2CAA2C;CAC3C,UAAU;CACV,oBAAoB;CACpB,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,2BAA2B;CAC3B,wCAAwC;CACxC,0CAA0C;CAC1C,2CAA2C;CAC3C,WAAW;CACX,oBAAoB;CACpB,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,mBAAmB;CACnB,YAAY;CACZ,aAAa;CACb,kBAAkB;CAClB,uCAAuC;AACxC;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,2CAA2C;AAC5C;;AAEA;CACC,mBAAmB;CACnB,UAAU;CACV,yBAAyB;AAC1B","sourcesContent":[".tooltip {\n\tdisplay: block !important;\n\tz-index: 10000;\n}\n\n.tooltip .tooltip-inner {\n\tbackground: #ccc;\n\tcolor: black;\n\tborder-radius: 10px;\n\tpadding: 5px 10px 4px;\n}\n\n.tooltip .tooltip-arrow {\n\twidth: 0;\n\theight: 0;\n\tborder-style: solid;\n\tposition: absolute;\n\tmargin: 5px;\n\tborder-color: #ccc;\n\tz-index: 1;\n}\n\n.tooltip[x-placement^=\"top\"] {\n\tmargin-bottom: 5px;\n}\n\n.tooltip[x-placement^=\"top\"] .tooltip-arrow {\n\tborder-width: 5px 5px 0 5px;\n\tborder-left-color: transparent !important;\n\tborder-right-color: transparent !important;\n\tborder-bottom-color: transparent !important;\n\tbottom: -5px;\n\tleft: calc(50% - 5px);\n\tmargin-top: 0;\n\tmargin-bottom: 0;\n}\n\n.tooltip[x-placement^=\"bottom\"] {\n\tmargin-top: 5px;\n}\n\n.tooltip[x-placement^=\"bottom\"] .tooltip-arrow {\n\tborder-width: 0 5px 5px 5px;\n\tborder-left-color: transparent !important;\n\tborder-right-color: transparent !important;\n\tborder-top-color: transparent !important;\n\ttop: -5px;\n\tleft: calc(50% - 5px);\n\tmargin-top: 0;\n\tmargin-bottom: 0;\n}\n\n.tooltip[x-placement^=\"right\"] {\n\tmargin-left: 5px;\n}\n\n.tooltip[x-placement^=\"right\"] .tooltip-arrow {\n\tborder-width: 5px 5px 5px 0;\n\tborder-left-color: transparent !important;\n\tborder-top-color: transparent !important;\n\tborder-bottom-color: transparent !important;\n\tleft: -5px;\n\ttop: calc(50% - 5px);\n\tmargin-left: 0;\n\tmargin-right: 0;\n}\n\n.tooltip[x-placement^=\"left\"] {\n\tmargin-right: 5px;\n}\n\n.tooltip[x-placement^=\"left\"] .tooltip-arrow {\n\tborder-width: 5px 0 5px 5px;\n\tborder-top-color: transparent !important;\n\tborder-right-color: transparent !important;\n\tborder-bottom-color: transparent !important;\n\tright: -5px;\n\ttop: calc(50% - 5px);\n\tmargin-left: 0;\n\tmargin-right: 0;\n}\n\n.tooltip.popover .popover-inner {\n\tbackground: #f9f9f9;\n\tcolor: black;\n\tpadding: 24px;\n\tborder-radius: 5px;\n\tbox-shadow: 0 5px 30px rgba(black, 0.1);\n}\n\n.tooltip.popover .popover-arrow {\n\tborder-color: #f9f9f9;\n}\n\n.tooltip[aria-hidden=\"true\"] {\n\tvisibility: hidden;\n\topacity: 0;\n\ttransition: opacity 0.15s, visibility 0.15s;\n}\n\n.tooltip[aria-hidden=\"false\"] {\n\tvisibility: visible;\n\topacity: 1;\n\ttransition: opacity 0.15s;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
